export default {
  405: {
    title: 'Account and Search not found',
    body: 'Check if the account and search are correct.',
    return: 'Back',
  },
  406: {
    title: 'Dashboard not found',
    body: 'Check your access with the dashboard administrator.',
    return: 'Back',
  },
  404: {
    title: 'Page not found',
    body: 'This page does not exist. Check the access link before continuing.',
    return: 'Back',
  },
  403: {
    title: 'Access not allowed',
    body: 'You do not have the necessary permission to access this page.',
    return: 'Back',
  },
  500: {
    title: 'Communication Error',
    body: 'The page took too long to respond. Refresh or try again.',
    return: 'Back',
  },
  noPermission: 'You do not have permission to perform this action.',
};
